import mori from 'mori';

/**
 * Filter the filtered data (again), to only
 * retain rows (locations) we are interested in
 * @param  {mori.vector} filteredData        [filtered data]
 * @param  {mori.vector} activeLocations     [active locations in footnotes]
 * @return {mori.vector}                     [relevent data]
 */
export default function getRelevantRows(
  filteredData,
  activeLocations,
  mergedLocationsDistributions,
) {
  return mori.map(
    (sheet) => mori.vector(
      mori.first(sheet),
      mori.filter(
        (item) => mori.some(
          (locationDistribution) => {
            const geo = mori.get(locationDistribution, 'geography', false);
            const distribution = mori.get(
              locationDistribution,
              'distribution',
              false
            );
            const distributionValue = mori.get(
              locationDistribution,
              'distributionValue',
              false
            );

            const itemKey = mori.first(mori.filter((key) => {
              return distribution === mori.first(key);
            }, mori.keys(item)));

            // Get the geography from the table data
            // Note: this should take the context into account.
            // It should not rely on State or Location only
            const itemGeo =
              mori.get(item, mori.set(['Location', 'Geography']), false)
              || mori.get(item, mori.set(['State', 'Geography']))
              || mori.get(item, mori.set(itemKey), false);

            const itemKeyVal = mori.get(item, itemKey);

            // `itemGeo` may be a summary row
            const summaryItem = (geo || '').toLocaleLowerCase() ===
              (itemGeo || '').toLocaleLowerCase().replace('(all)', '').trim();

            return (geo === itemGeo || summaryItem) && (
              distributionValue ? (distributionValue === itemKeyVal) : true
            );
          },
          mergedLocationsDistributions
        ),
        mori.flatten(mori.rest(sheet))
      )
    ),
    filteredData
  );
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/getFootnotes/getRelevantRows.js